import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'rename-document-name',
  templateUrl: './rename-document-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenameDocumentNameComponent {
  showNameError = false;
  editedFormName = this.data.suggestedFormName ?? '';

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<RenameDocumentNameComponent>) {}

  renameDocumentNameToSuggestedName() {
    const trimmedSuggestedFormName = this.editedFormName?.trim();
    if (!trimmedSuggestedFormName) {
      this.showNameError = true;
      return;
    }
    this.dialogRef.close({
      renameConfirmation: true,
      suggestedFormName: trimmedSuggestedFormName,
    });
  }

  dismissDocumentNameSuggestion() {
    this.dialogRef.close({
      dismissConfirmation: true,
    });
  }

  selectAllContent($event) {
    $event.target.select();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
